import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@unocss/reset/tailwind-compat.css";
import "virtual:uno.css";
import "./global.css";
import Clarity from "@microsoft/clarity";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { isProduction } from "./lib/constant.ts";

const CLARITY_PROJECT_ID = "p10h61a9jt";

function shouldEnableVConsole() {
  return !isProduction;
  // if (!isProduction) return true;
  // return (
  //   window.location.pathname === "/onramp" ||
  //   window.location.pathname.startsWith("/onramp/")
  // );
}

async function bootstrap() {
  if (isProduction) {
    Clarity.init(CLARITY_PROJECT_ID);
  }

  // Make sure VConsole is ready before any route (e.g. /onramp) loads.
  if (shouldEnableVConsole()) {
    const VConsole = (await import("vconsole")).default;
    new VConsole();
  }

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

void bootstrap();
